import { useEffect, useState } from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import dayjs from 'dayjs';
import { useParams, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Input } from '../../../../elements/input';
import { useTranslation } from 'react-i18next';
import { useHttpClient } from '../../../../shared/http-client';
import { FormFooter } from '../../../../elements/form-footer';
import { FieldError } from "../../../../elements/field-error/field-error";
import { Select } from '../../../../elements/select';
import { TextArea } from '../../../../elements/text-area';
import { FileInputElement } from '../../../../elements/file-input';


// construccion del objecto yup de validacion del cuestionario




export const AccidentesTabForm = ({
    item,
    exp,
    close,
    doDelete
}: {
    item?: any;
    exp?: any;
    close: () => void;
    doDelete?: (item: any) => void;
}) => {

    const { t } = useTranslation();
    const { id } = useParams();
    const { api, state } = useHttpClient();
    const [data, setData] = useState<any | null>(null);
    const [vehicles, setVehicles] = useState<any | null>([]);

    const [date, setDate] = useState<string>(item ? data?.date : dayjs().format('YYYY-MM-DDTHH:mm:ss'));
    const [isDeleted, setIsDeleted] = useState<boolean>(false);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        let value = e.target.value;

        setDate(value);

    };



    useEffect(() => {
        api('/fleet/vehicles/?limit=9999', 'GET');
    }, []);


    useEffect(() => {
        if (item) {
            setData(item);
        }
    }, [item]);

    const initialValues = {
        vehicle: '',
        driver: id,
        date: '',
        location: '',
        cost: '',
        status: ''


    };

    let obligado = {
        vehicle: Yup.string().required('obligatorio'),
        location: Yup.string().required('obligatorio'),
        //status: Yup.mixed().required('obligatorio'),
        //cost: Yup.string().required('obligatorio'),
        //date: Yup.mixed().required('obligatorio'),



    };

    const validacion = Yup.object().shape(obligado);

    const openInNewTab = () => {
        window.open(data?.display_url, '_blank', 'noreferrer');
    };


    const beforeSubmit = (values: any | null) => {
        let after = { ...values };



        const formattedDate = date ? new Date(date).toISOString().slice(0, 16) : "";

        after.date = formattedDate || data?.date;

        if (id) {
            after.driver = id;
        }

        delete after.name;

        return after;
    };

    const onSubmit = async (values: any | null) => {
        //
        const enviaremos = beforeSubmit(values);

        let formdata = new FormData();

        if (enviaremos.document) {
            if (enviaremos.document.document) {
                formdata.append(
                    'document',
                    enviaremos.document.document[0],
                    enviaremos.document.document[0].name
                );
            }
        }


        for (let key in enviaremos) {
            if (key !== 'document') {
                formdata.append(key, enviaremos[key] ? enviaremos[key] : "");
            }
        }

        if (isDeleted) {
            api(`/fleet/accidents/${enviaremos.id}/`, 'PATCH', enviaremos);
        } else {
            if (enviaremos.id) {
                // update

                api(`/fleet/accidents/${enviaremos.id}/`, 'PATCH', formdata, true);
            } else {
                // create

                api('/fleet/accidents/', 'POST', formdata, true);
            }
        }
    };

    const addNameToObjects = (arr: { plate: string }[]): { plate: string; name: string }[] => {
        return arr.map(obj => ({ ...obj, name: obj.plate }));
    };

    useEffect(() => {

        if (state.data) {

            if (state.path.includes('vehicles')) {

                setVehicles(addNameToObjects(state.data.results));
            }

            if (state.path.includes('accidents')) {
                if (state.method === 'POST' || state.method === 'PATCH') {
                    toast.success(`${t('common.label.success-saved')}`);
                    window.location.reload();
                    close();
                }
            }
        }

        if (state.error) {
            toast.error('Server Error');
        }
    }, [state]);

    return (
        <div>
            <Formik
                enableReinitialize={true}
                initialValues={data || initialValues}
                validationSchema={validacion}
                validateOnBlur={true}
                onSubmit={onSubmit}
            >
                {({
                    values,
                    errors,
                    touched,
                    setFieldValue,
                    handleSubmit,
                    isSubmitting
                }) => (
                    <form onSubmit={handleSubmit} autoComplete="off">
                        <div className="flex">
                            <div className="w-full">
                                <div className="my-[11px] w-full">
                                    <Select
                                        name="vehicle"
                                        label={t('common.label.vehiculo')}
                                        placeholder="Select"
                                        items={vehicles}
                                        value={values.vehicle}
                                        onChange={(value) => {
                                            setFieldValue('vehicle', value.vehicle);
                                        }}
                                    />
                                    <FieldError touched={touched} errors={errors} field={"vehicle"} />


                                    {/* --------------------FECHA------------------- */}

                                    <label className="block text-sm font-semibold leading-6 text-gray-700">
                                        {t('common.labels.date')}
                                    </label>
                                    <input
                                        id="dateInput"
                                        type="datetime-local"
                                        step="1" // Permite solo minutos (sin segundos)
                                        value={date || data?.date} // Mostrar sin segundos en el input
                                        onChange={handleChange}
                                    />

                                    <FieldError touched={touched} errors={errors} field={"date"} />
                                    {/* --------------------FECHA------------------- */}

                                    <div className='pt-4'>
                                        <Input
                                            label={t('common.label.ubicacion')}
                                            type="text"
                                            placeholder={t('common.label.ubicacion')}
                                            name="location"
                                            value={values.location}
                                            onChange={(value) =>
                                                setFieldValue('location', value.location)
                                            }
                                        />
                                        <FieldError
                                            touched={touched}
                                            errors={errors}
                                            field={'location'}
                                        />
                                    </div>


                                    <div>
                                        <TextArea
                                            label={t(
                                                'common.form-label.descripcion'
                                            )}
                                            placeholder={t(
                                                'common.form-label.descripcion'
                                            )}
                                            name="description"
                                            value={values.description}
                                            onChange={(value: any) =>
                                                setFieldValue(
                                                    'description',
                                                    value.description
                                                )
                                            }
                                        />
                                    </div>
                                    <div>
                                        <TextArea
                                            label={t(
                                                'common.form-label.damages'
                                            )}
                                            placeholder={t(
                                                'common.form-label.damages'
                                            )}
                                            name="damages"
                                            value={values.damages}
                                            onChange={(value: any) =>
                                                setFieldValue(
                                                    'damages',
                                                    value.damages
                                                )
                                            }
                                        />
                                    </div>
                                    <div>
                                        <TextArea
                                            label={t(
                                                'common.form-label.factors'
                                            )}
                                            placeholder={t(
                                                'common.form-label.factors'
                                            )}
                                            name="factors"
                                            value={values.factors}
                                            onChange={(value: any) =>
                                                setFieldValue(
                                                    'factors',
                                                    value.factors
                                                )
                                            }
                                        />
                                    </div>
                                    <div className='w-full'>
                                        <div className='pt-4'>
                                            {data?.document ? <div className='flex'>
                                                {!isDeleted ? <div className='flex cursor-pointer' onClick={openInNewTab}>
                                                    <span className='border border-gray-400 rounded py-2 px-4 text-sm'>{t('common.label.ver-document')}</span>
                                                </div> : ''}
                                                {!isDeleted ? <div className='flex cursor-pointer ml-8' onClick={() => {
                                                    setFieldValue('document', null);
                                                    setFieldValue('display_url', null);
                                                    setIsDeleted(true);
                                                }}>
                                                    <span className='border border-red-500 rounded p-2 text-sm text-red-500'>{t('common.button.delete-document')}</span>
                                                </div> : ''}
                                            </div> : ''
                                            }
                                        </div>

                                        <div className='w-full pt-4'>
                                            {id ? <span className="block text-sm font-semibold leading-6 text-gray-700">{data?.document ? t('common.label.cambiar-document') : t('common.form-label.documento')}</span> : ''}
                                            <FileInputElement
                                                name="document"
                                                accept={'image/png, image/jpeg, application/pdf'}
                                                onChange={(value) => {
                                                    // Extraemos directamente el FileList del objeto que retorna el FileInputElement
                                                    setFieldValue('document', value);
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className='pt-4 pb-8'>
                                        <Input
                                            label={t('common.label.costo')}
                                            type="number"
                                            placeholder={t('common.label.costo')}
                                            name="cost"
                                            value={values.cost}
                                            onChange={(value) =>
                                                setFieldValue('cost', value.cost)
                                            }
                                        />
                                        <FieldError
                                            touched={touched}
                                            errors={errors}
                                            field={'cost'}
                                        />
                                    </div>

                                </div>

                            </div>
                        </div>
                        <div className='h-24'></div>

                        <FormFooter
                            item={item}
                            doDelete={doDelete}
                            doSubmit={handleSubmit}
                            close={close}
                        />
                    </form>
                )}
            </Formik>
        </div>
    );
};